import { GridReadyEvent } from "@ag-grid-community/core";
import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, ReplaySubject, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class GridApiService implements OnDestroy {
  private destroy$ = new Subject<void>();
  gridApi$: Subject<GridReadyEvent> = new Subject();
  selectedRows$: Subject<any> = new ReplaySubject(1);
  changedColumnState$: Subject<any> = new ReplaySubject(1);
  showNotification$:BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
